import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const exportAccountingTransferOrderFormSchema = z
  .object({
    officeIds: z.array(z.string()).min(1, { message: 'form.errors.required' }),
    doctorAttendingIds: z.array(z.string()).optional(),
    period: z
      .object(
        {
          from: z.coerce.date(),
          to: z.coerce.date(),
        },
        { message: 'form.errors.required' },
      )
      .refine((p) => p.from <= p.to, {
        message: 'form.errors.invalid-period',
        path: ['to'],
      }),
  })
  .refine(
    (data) =>
      !(
        data.officeIds.length > 1 && (data.doctorAttendingIds?.length ?? 0) > 0
      ),
    {
      path: ['doctorAttendingIds'],
      message:
        'export-accounting-transfer-order-form.doctor-attending.only-single-office',
    },
  );

export type ExportAccountingTransferOrderFormValues = z.infer<
  typeof exportAccountingTransferOrderFormSchema
>;

export const exportAccountingTransferOrderFormResolver = zodResolver(
  exportAccountingTransferOrderFormSchema,
);
